import {
    createContext,
    FC,
    PropsWithChildren,
    useCallback,
    useContext,
    useState
} from 'react';

export interface Filter {
    value: any;
}

const filterContext = createContext<{
    state: Record<string, Record<string, Filter>>;
    setFilter: (table: string, column: string, value: Filter) => void;
}>({
    state: {},
    setFilter: () => null
});

export const FilterProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, setState] =
        useState<Record<string, Record<string, Filter>>>(null);

    const setFilter = useCallback(
        (table: string, column: string, filter: Filter) => {
            setState((current) => ({
                ...current,
                [table]: {
                    ...current?.[table],
                    [column]: filter?.value
                }
            }));
        },
        []
    );

    return (
        <filterContext.Provider
            value={{
                state,
                setFilter
            }}>
            {children}
        </filterContext.Provider>
    );
};

export const useFilter = () => useContext(filterContext);
